import React from "react";

const Terms = () => {
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <div>
                <div className="card-header">
                  <h3 className="card-title">Privacy @ FarmMobi</h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <dl>
                    <dd>
                      FarmMobi respects your preferences concerning the
                      collection and use of your Personal Information. The
                      following FarmMobi privacy policies are tailored for the
                      different ways your Personal Information may be collected,
                      used, shared and processed by different FarmMobi lines of
                      business: <dt>General Privacy Policy</dt>The FarmMobi
                      General Privacy Policy addresses information we collect in
                      connection with your use of FarmMobi websites, mobile
                      applications, and social media pages that link to the
                      General Privacy Policy, your interactions with FarmMobi
                      during in-person meetings at FarmMobi facilities or at
                      FarmMobi events, and in the context of other online or
                      offline sales and marketing activities.
                      <br />
                      <br />
                      <dt>Services Privacy Policy </dt>
                      The Services Privacy Policy describes our privacy and
                      security practices that apply when handling (i) services
                      personal information in order to perform Consulting,
                      Technical Support, Cloud and other services on behalf of
                      FarmMobi customers; and (ii) personal information
                      contained in systems operation data generated by the
                      interaction of (end-)users of these services with FarmMobi
                      systems and networks.
                      <br /> <br />
                      <dt>Data Research and Development Privacy Policy</dt>
                      The Customer Data Research and Development Privacy Policy
                      describes FarmMobi’s processing of personal information in
                      connection with FarmMobi’s artificial intelligence and
                      machine learning activities in order to analyze, develop,
                      and improve FarmMobi products and services, and for
                      security and compliance purposes. <br />
                      <br />
                      <dt>Recruiting  and Advertising Privacy Policy</dt>
                      The FarmMobi Recruiting Privacy Policy addresses
                      information we may collect in connection with FarmMobi’s
                      online and offline recruiting efforts. The FarmMobi
                      Advertising Privacy Policy addresses how FarmMobi
                      facilitates the collection and use of marketing and
                      interest-based information to help enable interest-based
                      advertising by our FarmMobi Advertising customers.
                      <br />
                      <br />
                      The AddThis Privacy Policy informs consumers about the
                      collection, use and sharing of personal information in
                      connection with FarmMobi’s provision of the Add This
                      Tools. Contact information for Data Protection Authorities
                      and Country Specific Disclosures
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Terms;
